import React from 'react';
import { useSelector } from 'react-redux';
import * as Styled from './ObjectiveHint.styled';
import { currentHintSelector } from '../../slices/ObjectivesSlice';
import { Icon } from '@virtidev/toolbox';

const ObjectiveHint = () => {
  const currentHint = useSelector(currentHintSelector);
  if (!currentHint?.text) {
    return <></>;
  }
  return (
    <Styled.HintWrapper>
      <Styled.IconWrapper>
        <Icon
          size="2rem"
          color="var(--secondary-color)"
          icon="support"
          type="outline"
        />
      </Styled.IconWrapper>
      <Styled.HintText>{currentHint.text}</Styled.HintText>
    </Styled.HintWrapper>
  );
};

export default ObjectiveHint;
